const initState = {
  subtopics: [],
};

const schemesReducer = (state = initState, action) => {
  switch (action.type) {
    case "ADDED_SCHEMES":
      return {
        ...state,
        addSchemesSuccess: {
          message: action.message,
          type: "addSchemesSuccess",
          id: action.id,
        },
      };
    case "ADDED_SCHEMES_ERROR":
      return {
        ...state,
        addSchemesError: {
          message: action.err.message,
          type: "addSchemesError",
        },
      };

    case "UPDATED_SCHEMES":
      return {
        ...state,
        updateSchemesSuccess: {
          message: action.message,
          type: "updateSchemesSuccess",
        },
      };
    case "UPDATED_SCHEMES_ERROR":
      return {
        ...state,
        updateSchemesError: {
          message: action.err.message,
          type: "updateSchemesError",
        },
      };

    case "DELETED_SCHEMES":
      return {
        ...state,
        deleteSchemesSuccess: {
          message: action.message,
          type: "deleteSchemesSuccess",
        },
      };

    case "DELETED_SCHEMES_ERROR":
      return {
        ...state,
        deleteSchemesError: {
          message: action.err.message,
          type: "deleteSchemesError",
        },
      };

    default:
      return state;
  }
};

export default schemesReducer;
